module.exports = __webpack_public_path__ + "static/media/expiredAlert.d4b617ee.svg";